<template>
  <div class="package-course" @click="onCourseClick">
    <img
      v-if="course.packageCourseStatus == 1"
      class="package-course_apply"
      src="@/assets/images/package/course-apply@2x.png"
    />
    <img class="package-course_cover" :src="course.cover_img" />
    <div class="package-course_right">
      <div class="package-course_title">
        {{ course.course_title }}
      </div>
      <div class="package-course_num">
        <span v-if="course.valid_type == 1">长期有效</span>
        <span v-else-if="course.valid_type == 2">
          {{ course.valid_time | tsFormat("yyyy/MM/dd") }}截止
        </span>
        <span v-else-if="course.valid_type == 3">
          {{ course.valid_time }}天内有效
        </span>
        <span>|</span>
        <span>{{ course.section_num }}课时</span>
      </div>
      <div class="package-course_footer">
        <div class="flex-row">
          <img class="package-course_avatar" :src="course.avatar" />
          <span>
            {{ course.teachers_name }}
          </span>
        </div>
        <CurrencyNew
          :price="course.price"
          :priceUnderline="course.underlined_price"
        ></CurrencyNew>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "PackageCourse",
  props: {
    course: {
      type: Object,
      default: () => {},
    },
    is_small_course_open:Number
  },
  methods: {
    onCourseClick() {

    if(this.is_small_course_open==1) return
      this.$router.push({
        name: "CourseShow",
        params: { id: this.course.course_id },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.package-course {
  height: 146px;
  display: flex;
  border-radius: 4px;
  position: relative;
  cursor: pointer;

  /deep/ {
    .price-wrap {
      .price {
        font-size: 16px;
      }
      .price-underline {
        margin-right: 11px;
      }
    }
  }
}

.package-course_cover {
  width: 220px;
  height: 100%;
  border-radius: 4px 0 0 4px;
}

.package-course_right {
  position: relative;
  width: 337px;
  box-sizing: border-box;
  padding-left: 18px;
  border: 1px solid #e0e0e0;
  border-left: none;
  border-radius: 0 4px 4px 0;
}

.package-course_title {
  font-size: 16px;
  color: #333333;
  padding-top: 15px;
}

.package-course_num {
  font-size: 14px;
  color: #999999;
  padding-top: 11px;

  span:nth-child(2) {
    margin: 0 5px;
  }
}

.package-course_footer {
  position: absolute;
  width: 100%;
  box-sizing: border-box;
  left: 0;
  bottom: 13px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 18px;
}

.package-course_avatar {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  margin-right: 6px;
}

.package-course_apply {
  position: absolute;
  width: 58px;
  height: 58px;
  top: 0;
  left: 162px;
}
</style>
